import createIcon from '../../createIcon';

/**
 * @component @name ViewCompactAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNEg0QzIuOSA0IDIgNC45IDIgNlYxOEMyIDE5LjEgMi45IDIwIDQgMjBIMjBDMjEuMSAyMCAyMiAxOS4xIDIyIDE4VjZDMjIgNC45IDIxLjEgNCAyMCA0Wk0xMS41IDE2LjVINy41VjEyLjVIMTEuNVYxNi41Wk0xMS41IDExLjVINy41VjcuNUgxMS41VjExLjVaTTE2LjUgMTYuNUgxMi41VjEyLjVIMTYuNVYxNi41Wk0xNi41IDExLjVIMTIuNVY3LjVIMTYuNVYxMS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewCompactAlt = createIcon('ViewCompactAlt', [
  [
    'path',
    {
      d: 'M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM11.5 16.5H7.5V12.5H11.5V16.5ZM11.5 11.5H7.5V7.5H11.5V11.5ZM16.5 16.5H12.5V12.5H16.5V16.5ZM16.5 11.5H12.5V7.5H16.5V11.5Z',
      key: '1vvycw',
    },
  ],
]);

export default ViewCompactAlt;
